// libs
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

// apis
import { getLoggedInUser } from "shared/api/auth";
import { getMenuData } from "shared/api/misc";
import { getOfferText } from "shared/api/offer";

// Helpers
import { NormalizeMenu } from "shared/api/helpers/menu";
import logger from "shared/logger";

// constants
import MemoizeAPIWithTTL from "shared/helpers/memoizeAPIWithTTL";
import { API_CACHE_TTL } from "shared/constants";

// redux store
import { ActionTypes } from "./actions";

const memoizedGetMenuData = MemoizeAPIWithTTL(getMenuData, API_CACHE_TTL);

export const fetchMenuData = (): any => {
    return (dispatch: any) => {
        dispatch({ type: ActionTypes.FETCH_MENU_PROGRESS });
        return memoizedGetMenuData()
            .then(data => {
                if (isEmpty(data.response)) {
                    logger.error({ ERROR: "MANDATORY_FIELD_EMPTY", METHOD_NAME: "getMenuData" });
                }

                dispatch({
                    type: ActionTypes.FETCH_MENU_SUCCESS,
                    payload: NormalizeMenu(data.response),
                });
            })
            .catch(() => {
                dispatch({ type: ActionTypes.FETCH_MENU_FAILED });
            });
    };
};

export const fetchUser = (): any => {
    return (dispatch: any) => {
        dispatch({ type: ActionTypes.FETCH_USER_PROGRESS });
        return getLoggedInUser()
            .then(data => {
                const { form_Key: formKey, cartCount, customerData, base_location } = data.response;
                dispatch({
                    type: ActionTypes.FETCH_USER_SUCCESS,
                    payload: { formKey, cartCount, customerData, base_location },
                });
            })
            .catch(() => {
                dispatch({ type: ActionTypes.FETCH_MENU_FAILED });
            });
    };
};

export const fetchOffer = (): any => {
    return (dispatch: any) => {
        dispatch({ type: ActionTypes.FETCH_HEADER_OFFER });
        return getOfferText()
            .then(data => {
                dispatch({
                    type: ActionTypes.SET_HEADER_OFFER,
                    payload: get(data, "response.header_top.0", {}),
                });
            })
            .catch(() => {
                dispatch({ type: ActionTypes.FETCH_HEADER_OFFER_FAILED });
            });
    };
};
